import { memo, useEffect, useState } from "react";
import { ErrorData } from "../config/interfaces";

interface ITimer {
  expireTime: string;
  setTimerOn: React.Dispatch<React.SetStateAction<boolean>>;
  setState: React.Dispatch<React.SetStateAction<ErrorData>>;
  signUpReady: boolean;
}

const INTERVAL = 1000;
const NOW = new Date(Date.now()).getTime();
const UTC = new Date(Date.now()).getTimezoneOffset() * 60 * 1000;

export const Timer = memo(
  ({ expireTime, setTimerOn, setState, signUpReady }: ITimer) => {
    const nowTime = NOW + UTC;
    const exTime = new Date(expireTime).getTime();

    const [timeLeft, setTimeLeft] = useState<number>(exTime - nowTime);

    const minutes = String(Math.floor((timeLeft / (1000 * 60)) % 60)).padStart(
      2,
      "0"
    );
    const seconds = String(Math.floor((timeLeft / 1000) % 60)).padStart(2, "0");

    useEffect(() => {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - INTERVAL);
      }, INTERVAL);

      if (timeLeft <= 0) {
        clearInterval(timer);
        setTimerOn(false);
        setState({
          error: true,
          message: "Please try again.",
        });
      } else if (signUpReady) {
        clearInterval(timer);
        setTimerOn(false);
      }

      return () => {
        clearInterval(timer);
      };
    }, [setState, setTimerOn, signUpReady, timeLeft]);

    return (
      <div>
        {minutes} : {seconds}
      </div>
    );
  }
);
